
var taskQueue = {
    isRunning: false,
    queue: [],
    currentTask : null,
    tasks: 0,

    add: function(task) {
        taskQueue.queue.push(task);
        taskQueue.tasks += 1;
        if (!taskQueue.isRunning) {
            taskQueue.run();
        } else {
            progress.setText('Speichere '+ (taskQueue.tasks - taskQueue.queue.length) +'/'+ taskQueue.tasks);
            if (taskQueue.tasks > 1) {
                progress.setState(100 - ((taskQueue.queue.length / taskQueue.tasks) * 100));
            }
        }
    },

    onError: function(message, tryAgain, onRevert) {
        if ((tryAgain || false) == true && taskQueue.currentTask.errorCount < 3) {
            taskQueue.currentTask.errorCount++;
            taskQueue.executeTask(taskQueue.currentTask);
            return;
        }
        //
        messaging.askYesNo('Fehler in der Bearbeitung', message + '<br/><br/> Nochmals versuchen?', function() {
            taskQueue.currentTask.errorCount++;
            taskQueue.executeTask(taskQueue.currentTask);
        }, function() {
            if (onRevert) onRevert();
            taskQueue.run();
        });
    },

    run: function() {
        if (taskQueue.queue.length <= 0) {
            taskQueue.isRunning = false;
            taskQueue.tasks = 0;
            progress.endProgress();
            return;
        }
        //
        progress.startProgress('Speichere '+ (taskQueue.tasks - taskQueue.queue.length) +'/'+ taskQueue.tasks);
        if (taskQueue.tasks > 1) {
            progress.setState(100 - ((taskQueue.queue.length / taskQueue.tasks) * 100));
        }
        taskQueue.isRunning = true;
        taskQueue.currentTask = taskQueue.queue.shift();
        taskQueue.executeTask(taskQueue.currentTask);
    },

    executeTask: function(task) {
        task.errorCount = 0;
        task.run(taskQueue.run, taskQueue.onError, task);
    }

};
window.taskQueue = taskQueue;
